'use strict';
import * as $j_app$002edata$002e$002dPayment$002dDetails$0024package$0024$002dBank$002dSort$002dCode$0024 from "./app.data.-Payment-Details$package$-Bank-Sort-Code$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_PaymentDetails$package$BankSortCodeForm$() {
  this.aEu = null;
  this.aEH = null;
  this.aEz = null;
  this.aEA = false;
  this.aEF = null;
  this.aEG = false;
  this.aEv = null;
  this.aEw = false;
  this.aED = null;
  this.aEE = false;
  this.aEB = null;
  this.aEC = false;
  this.aEx = null;
  this.aEy = false;
  $n_Lapp_data_PaymentDetails$package$BankSortCodeForm$ = this;
  this.aEu = $j_app$002edata$002e$002dPayment$002dDetails$0024package$0024$002dBank$002dSort$002dCode$0024.$m_Lapp_data_PaymentDetails$package$BankSortCode$();
  this.aEH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002e$002dPayment$002dDetails$0024package$0024$002dBank$002dSort$002dCode$0024.$m_Lapp_data_PaymentDetails$package$BankSortCode$());
}
export { $c_Lapp_data_PaymentDetails$package$BankSortCodeForm$ as $c_Lapp_data_PaymentDetails$package$BankSortCodeForm$ };
$p = $c_Lapp_data_PaymentDetails$package$BankSortCodeForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_PaymentDetails$package$BankSortCodeForm$;
/** @constructor */
function $h_Lapp_data_PaymentDetails$package$BankSortCodeForm$() {
}
export { $h_Lapp_data_PaymentDetails$package$BankSortCodeForm$ as $h_Lapp_data_PaymentDetails$package$BankSortCodeForm$ };
$h_Lapp_data_PaymentDetails$package$BankSortCodeForm$.prototype = $p;
$p.eR = (function() {
  return this.aEu;
});
$p.eO = (function() {
  return this.aEH;
});
$p.b9 = (function() {
  if ((!this.aEA)) {
    this.aEz = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aEA = true;
  }
  return this.aEz;
});
$p.b3 = (function() {
  if ((!this.aEG)) {
    this.aEF = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aEG = true;
  }
  return this.aEF;
});
$p.aG = (function() {
  if ((!this.aEw)) {
    this.aEv = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aEw = true;
  }
  return this.aEv;
});
$p.az = (function() {
  if ((!this.aEE)) {
    this.aED = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aEE = true;
  }
  return this.aED;
});
$p.aY = (function() {
  if ((!this.aEC)) {
    this.aEB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aEC = true;
  }
  return this.aEB;
});
$p.brU = (function() {
  if ((!this.aEy)) {
    this.aEx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Bank Sort Code";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aEy = true;
  }
  return this.aEx;
});
var $d_Lapp_data_PaymentDetails$package$BankSortCodeForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PaymentDetails$package$BankSortCodeForm$, "app.data.PaymentDetails$package$BankSortCodeForm$", ({
  EF: 1,
  N: 1
}));
export { $d_Lapp_data_PaymentDetails$package$BankSortCodeForm$ as $d_Lapp_data_PaymentDetails$package$BankSortCodeForm$ };
var $n_Lapp_data_PaymentDetails$package$BankSortCodeForm$;
function $m_Lapp_data_PaymentDetails$package$BankSortCodeForm$() {
  if ((!$n_Lapp_data_PaymentDetails$package$BankSortCodeForm$)) {
    $n_Lapp_data_PaymentDetails$package$BankSortCodeForm$ = new $c_Lapp_data_PaymentDetails$package$BankSortCodeForm$();
  }
  return $n_Lapp_data_PaymentDetails$package$BankSortCodeForm$;
}
export { $m_Lapp_data_PaymentDetails$package$BankSortCodeForm$ as $m_Lapp_data_PaymentDetails$package$BankSortCodeForm$ };
//# sourceMappingURL=app.data.-Payment-Details$package$-Bank-Sort-Code-Form$.js.map
